import React from "react";

export default React.createContext({
  cart: [],
  addProductToCart: (slab) => {},
  removeProductFromCart: (slabId) => {},
  clearCart: () => {},
});
